import { render, staticRenderFns } from "./BaseInputSearch.vue?vue&type=template&id=47c3b25c&scoped=true&"
import script from "./BaseInputSearch.vue?vue&type=script&lang=js&"
export * from "./BaseInputSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSearch.vue?vue&type=style&index=0&id=47c3b25c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3b25c",
  null
  
)

export default component.exports